import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { computed, forwardRef, signal } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoFocusModule } from 'prime-ng-old/autofocus';
import { Dropdown as DropdownBase, DropdownItem as DropdownBaseItem } from 'prime-ng-old/dropdown';
import { ChevronDownIcon } from 'prime-ng-old/icons/chevrondown';
import { SearchIcon } from 'prime-ng-old/icons/search';
import { TimesIcon } from 'prime-ng-old/icons/times';
import { OverlayModule } from 'prime-ng-old/overlay';
import { ScrollerModule } from 'prime-ng-old/scroller';
import { ObjectUtils } from 'prime-ng-old/utils';
import { FIELD_WRAPPER_LISTENER } from '../field-wrapper-listener/field-wrapper-listener';
import { INPUT_OPTIONS_DYNAMIC_HOST } from '../input-options-dynamic/supported_component';
import { OPTIONS_GROUPED_BY_HOST } from '../input-options-grouped-by/supported_component';
import { UiHeaderFooterBundle } from '../shared';
import { UiSpinnerComponent } from '../spinner';
import { createPlaceholderEntryItem } from '../utils';
import { SharedModule } from 'prime-ng-old/api';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../input-ref/input-ref.directive";
import * as i3 from "../input-ref/form-control-name";
import * as i4 from "prime-ng-old/autofocus";
import * as i5 from "prime-ng-old/overlay";
import * as i6 from "primeng/api";
import * as i7 from "prime-ng-old/scroller";
const _c0 = a0 => ({
  height: a0
});
const _c1 = (a0, a1, a2) => ({
  "p-dropdown-item": true,
  "p-highlight": a0,
  "p-disabled": a1,
  "p-focus": a2
});
const _c2 = a0 => ({
  $implicit: a0
});
function DropdownItem_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label ?? "empty");
  }
}
function DropdownItem_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c3 = a0 => ({
  "p-dropdown-label p-input-text p-inputtext p-placeholder": true,
  "p-dropdown-label-empty": a0
});
const _c4 = a0 => ({
  options: a0
});
const _c5 = (a0, a1) => ({
  $implicit: a0,
  options: a1
});
const _c6 = () => ({});
const _c7 = a0 => ({
  "p-dropdown-placeholder-item": a0
});
function UiInputDropdownComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.label() === "p-emptylabel" ? "\u00A0" : ctx_r2.label(), " ");
  }
}
function UiInputDropdownComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 25);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.selectedItemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, ctx_r2.selectedOption));
  }
}
function UiInputDropdownComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.placeholder());
  }
}
function UiInputDropdownComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 24, 5);
    i0.ɵɵlistener("focus", function UiInputDropdownComponent_Conditional_2_Template_span_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputFocus($event));
    })("blur", function UiInputDropdownComponent_Conditional_2_Template_span_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputBlur($event));
    })("keydown", function UiInputDropdownComponent_Conditional_2_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onKeyDown($event, false));
    });
    i0.ɵɵconditionalCreate(2, UiInputDropdownComponent_Conditional_2_Conditional_2_Template, 1, 1);
    i0.ɵɵconditionalCreate(3, UiInputDropdownComponent_Conditional_2_Conditional_3_Template, 1, 4, "ng-container", 25);
    i0.ɵɵconditionalCreate(4, UiInputDropdownComponent_Conditional_2_Conditional_4_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.inputClass)("autofocus", ctx_r2.autofocus);
    i0.ɵɵattribute("aria-disabled", ctx_r2.disabled)("id", ctx_r2.inputId)("aria-label", ctx_r2.ariaLabel || (ctx_r2.label() === "p-emptylabel" ? undefined : ctx_r2.label()))("aria-labelledby", ctx_r2.ariaLabelledBy)("aria-haspopup", "listbox")("aria-expanded", ctx_r2.overlayVisible)("aria-controls", ctx_r2.id + "_list")("tabindex", !ctx_r2.disabled ? ctx_r2.tabindex : -1)("aria-activedescendant", ctx_r2.focused ? ctx_r2.focusedOptionId : undefined)("aria-required", ctx_r2.required)("required", ctx_r2.required);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r2.selectedItemTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.selectedItemTemplate && ctx_r2.selectedOption ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.showPlaceholder() ? 4 : -1);
  }
}
function UiInputDropdownComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r2.placeholder == null || ctx_r2.placeholder.length === 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.placeholder || "empty");
  }
}
function UiInputDropdownComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 26, 6);
    i0.ɵɵlistener("input", function UiInputDropdownComponent_Conditional_4_Template_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onEditableInput($event));
    })("keydown", function UiInputDropdownComponent_Conditional_4_Template_input_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onKeyDown($event, false));
    })("focus", function UiInputDropdownComponent_Conditional_4_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputFocus($event));
    })("blur", function UiInputDropdownComponent_Conditional_4_Template_input_blur_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onInputBlur($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.inputClass)("disabled", ctx_r2.disabled);
    i0.ɵɵattribute("maxlength", ctx_r2.maxlength)("placeholder", ctx_r2.modelValue() === undefined || ctx_r2.modelValue() === null ? ctx_r2.placeholder() : undefined)("aria-expanded", ctx_r2.overlayVisible);
  }
}
function UiInputDropdownComponent_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "TimesIcon", 29);
    i0.ɵɵlistener("click", function UiInputDropdownComponent_Conditional_5_Conditional_0_Template_TimesIcon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clear($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-dropdown-clear-icon");
    i0.ɵɵattribute("data-pc-section", "clearicon");
  }
}
function UiInputDropdownComponent_Conditional_5_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function UiInputDropdownComponent_Conditional_5_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_5_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiInputDropdownComponent_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵlistener("click", function UiInputDropdownComponent_Conditional_5_Conditional_1_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.clear($event));
    });
    i0.ɵɵtemplate(1, UiInputDropdownComponent_Conditional_5_Conditional_1_1_Template, 1, 0, null, 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "clearicon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.clearIconTemplate);
  }
}
function UiInputDropdownComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiInputDropdownComponent_Conditional_5_Conditional_0_Template, 1, 2, "TimesIcon", 27);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_Conditional_5_Conditional_1_Template, 2, 2, "span", 28);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r2.clearIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.clearIconTemplate ? 1 : -1);
  }
}
function UiInputDropdownComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 31);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r2.dropdownIcon);
  }
}
function UiInputDropdownComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronDownIcon", 27);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-dropdown-trigger-icon");
  }
}
function UiInputDropdownComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiInputDropdownComponent_Conditional_7_Conditional_0_Template, 1, 1, "span", 31);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_Conditional_7_Conditional_1_Template, 1, 1, "ChevronDownIcon", 27);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.dropdownIcon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.dropdownIcon ? 1 : -1);
  }
}
function UiInputDropdownComponent_Conditional_8_1_ng_template_0_Template(rf, ctx) {}
function UiInputDropdownComponent_Conditional_8_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_8_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiInputDropdownComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, UiInputDropdownComponent_Conditional_8_1_Template, 1, 0, null, 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.dropdownIconTemplate);
  }
}
function UiInputDropdownComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "ui-spinner", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 18)("margin", false)("inline", true);
  }
}
function UiInputDropdownComponent_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_16_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.filterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r2.filterOptions));
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 27);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-dropdown-filter-icon");
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_1_ng_template_0_Template(rf, ctx) {}
function UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtemplate(1, UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_1_Template, 1, 0, null, 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.filterIconTemplate);
  }
}
function UiInputDropdownComponent_Conditional_16_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "input", 36, 7);
    i0.ɵɵlistener("input", function UiInputDropdownComponent_Conditional_16_Conditional_2_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onFilterInputChange($event));
    })("keydown", function UiInputDropdownComponent_Conditional_16_Conditional_2_Template_input_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onFilterKeyDown($event));
    })("blur", function UiInputDropdownComponent_Conditional_16_Conditional_2_Template_input_blur_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onFilterBlur($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_3_Template, 1, 1, "SearchIcon", 27);
    i0.ɵɵconditionalCreate(4, UiInputDropdownComponent_Conditional_16_Conditional_2_Conditional_4_Template, 2, 1, "span", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r2._filterValue() || "");
    i0.ɵɵattribute("placeholder", ctx_r2.filterPlaceholder)("aria-owns", ctx_r2.id + "_list")("aria-label", ctx_r2.ariaFilterLabel)("aria-activedescendant", ctx_r2.focusedOptionId);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r2.filterIconTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.filterIconTemplate ? 4 : -1);
  }
}
function UiInputDropdownComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function UiInputDropdownComponent_Conditional_16_Template_div_click_0_listener($event) {
      return $event.stopPropagation();
    });
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_Conditional_16_Conditional_1_Template, 1, 4, "ng-container")(2, UiInputDropdownComponent_Conditional_16_Conditional_2_Template, 5, 7, "div", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.filterTemplate ? 1 : 2);
  }
}
function UiInputDropdownComponent_Conditional_18_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_Conditional_18_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_18_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const items_r9 = ctx.$implicit;
    const scrollerOptions_r10 = ctx.options;
    i0.ɵɵnextContext(2);
    const buildInItems_r11 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", buildInItems_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c5, items_r9, scrollerOptions_r10));
  }
}
function UiInputDropdownComponent_Conditional_18_Conditional_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_Conditional_18_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_18_Conditional_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const scrollerOptions_r12 = ctx.options;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.loaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, scrollerOptions_r12));
  }
}
function UiInputDropdownComponent_Conditional_18_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_18_Conditional_3_ng_template_0_Template, 1, 4, "ng-template", 40);
  }
}
function UiInputDropdownComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-scroller", 38, 8);
    i0.ɵɵlistener("onLazyLoad", function UiInputDropdownComponent_Conditional_18_Template_p_scroller_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onLazyLoad.emit($event));
    });
    i0.ɵɵtemplate(2, UiInputDropdownComponent_Conditional_18_ng_template_2_Template, 1, 5, "ng-template", 39);
    i0.ɵɵconditionalCreate(3, UiInputDropdownComponent_Conditional_18_Conditional_3_Template, 1, 0, null, 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(8, _c0, ctx_r2.scrollHeight));
    i0.ɵɵproperty("items", ctx_r2.visibleOptions())("itemSize", ctx_r2.virtualScrollItemSize || ctx_r2._itemSize)("autoSize", true)("lazy", ctx_r2.lazy)("options", ctx_r2.virtualScrollOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.loaderTemplate ? 3 : -1);
  }
}
function UiInputDropdownComponent_Conditional_19_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_Conditional_19_ng_container_0_Template, 1, 0, "ng-container", 35);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const buildInItems_r11 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", buildInItems_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c5, ctx_r2.visibleOptions(), i0.ɵɵpureFunction0(2, _c6)));
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdownItem", 46);
    i0.ɵɵlistener("onClick", function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_0_Template_p_dropdownItem_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const option_r14 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onOptionSelect($event, option_r14));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("option", null)("selected", false)("label", option_r14.optionGroup.name)("disabled", false);
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r14 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.getOptionGroupLabel(option_r14.optionGroup));
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 45);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_Conditional_1_Template, 2, 1, "span");
    i0.ɵɵtemplate(2, UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_ng_container_2_Template, 1, 0, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    const option_r14 = ctx_r14.$implicit;
    const ɵ$index_114_r16 = ctx_r14.$index;
    const scrollerOptions_r17 = i0.ɵɵnextContext().options;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c0, scrollerOptions_r17.itemSize + "px"));
    i0.ɵɵattribute("id", ctx_r2.id + "_" + ctx_r2.getOptionIndex(ɵ$index_114_r16, scrollerOptions_r17));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.groupTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.groupTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c2, option_r14.optionGroup));
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_0_Template, 1, 4, "p-dropdownItem", 44);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Conditional_1_Template, 3, 9, "li", 45);
  }
  if (rf & 2) {
    const option_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.isPlaceholderItem(option_r14) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.isPlaceholderItem(option_r14) ? 1 : -1);
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdownItem", 47);
    i0.ɵɵlistener("onClick", function UiInputDropdownComponent_ng_template_20_For_3_Conditional_1_Template_p_dropdownItem_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const option_r14 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.onOptionSelect($event, option_r14));
    })("onMouseEnter", function UiInputDropdownComponent_ng_template_20_For_3_Conditional_1_Template_p_dropdownItem_onMouseEnter_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ɵ$index_114_r16 = i0.ɵɵnextContext().$index;
      const scrollerOptions_r17 = i0.ɵɵnextContext().options;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onOptionMouseEnter($event, ctx_r2.getOptionIndex(ɵ$index_114_r16, scrollerOptions_r17)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    const option_r14 = ctx_r14.$implicit;
    const ɵ$index_114_r16 = ctx_r14.$index;
    const scrollerOptions_r17 = i0.ɵɵnextContext().options;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7, ctx_r2.isPlaceholderItem(option_r14)))("id", ctx_r2.id + "_" + ctx_r2.getOptionIndex(ɵ$index_114_r16, scrollerOptions_r17))("option", option_r14)("selected", ctx_r2.isSelected(option_r14))("label", ctx_r2.getOptionLabel(option_r14))("disabled", ctx_r2.isOptionDisabled(option_r14))("template", ctx_r2.itemTemplate)("focused", ctx_r2.focusedOptionIndex() === ctx_r2.getOptionIndex(ɵ$index_114_r16, scrollerOptions_r17))("ariaPosInset", ctx_r2.getAriaPosInset(ctx_r2.getOptionIndex(ɵ$index_114_r16, scrollerOptions_r17)))("ariaSetSize", ctx_r2.ariaSetSize);
  }
}
function UiInputDropdownComponent_ng_template_20_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiInputDropdownComponent_ng_template_20_For_3_Conditional_0_Template, 2, 2);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_ng_template_20_For_3_Conditional_1_Template, 1, 12, "p-dropdownItem", 43);
  }
  if (rf & 2) {
    const option_r14 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.isOptionGroup(option_r14) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.isOptionGroup(option_r14) ? 1 : -1);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.emptyFilterMessageLabel, " ");
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyFilterTemplate || ctx_r2.emptyTemplate);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 42);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_1_Template, 1, 1)(2, UiInputDropdownComponent_ng_template_20_Conditional_4_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r17 = i0.ɵɵnextContext().options;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0, scrollerOptions_r17.itemSize + "px"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.emptyFilterTemplate && !ctx_r2.emptyTemplate ? 1 : 2);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.emptyMessageLabel, " ");
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 20);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.emptyTemplate);
  }
}
function UiInputDropdownComponent_ng_template_20_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 42);
    i0.ɵɵconditionalCreate(1, UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_1_Template, 1, 1)(2, UiInputDropdownComponent_ng_template_20_Conditional_5_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r17 = i0.ɵɵnextContext().options;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0, scrollerOptions_r17.itemSize + "px"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.emptyTemplate ? 1 : 2);
  }
}
function UiInputDropdownComponent_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 41, 9);
    i0.ɵɵrepeaterCreate(2, UiInputDropdownComponent_ng_template_20_For_3_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵconditionalCreate(4, UiInputDropdownComponent_ng_template_20_Conditional_4_Template, 3, 4, "li", 42);
    i0.ɵɵconditionalCreate(5, UiInputDropdownComponent_ng_template_20_Conditional_5_Template, 3, 4, "li", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r19 = ctx.$implicit;
    const scrollerOptions_r17 = ctx.options;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(scrollerOptions_r17.contentStyle);
    i0.ɵɵproperty("ngClass", scrollerOptions_r17.contentStyleClass);
    i0.ɵɵattribute("id", ctx_r2.id + "_list");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(items_r19);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.filterValue && ctx_r2.isEmpty() ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.filterValue && ctx_r2.isEmpty() ? 5 : -1);
  }
}
function UiInputDropdownComponent_ng_container_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c8 = "@layer primeng{.p-dropdown{display:inline-flex;cursor:pointer;position:relative;-webkit-user-select:none;user-select:none}.p-dropdown-clear-icon{position:absolute;top:50%;margin-top:-.5rem}.p-dropdown-trigger{display:flex;align-items:center;justify-content:center;flex-shrink:0}.p-dropdown-label{display:block;white-space:nowrap;overflow:hidden;flex:1 1 auto;width:1%;text-overflow:ellipsis;cursor:pointer}.p-dropdown-label-empty{overflow:hidden;opacity:0}input.p-dropdown-label{cursor:default}.p-dropdown .p-dropdown-panel{min-width:100%}.p-dropdown-items-wrapper{overflow:auto}.p-dropdown-item{cursor:pointer;font-weight:400;white-space:nowrap;position:relative;overflow:hidden}.p-dropdown-item-group{cursor:auto}.p-dropdown-items{margin:0;padding:0;list-style-type:none}.p-dropdown-filter{width:100%}.p-dropdown-filter-container{position:relative}.p-dropdown-filter-icon{position:absolute;top:50%;margin-top:-.5rem}.p-fluid .p-dropdown{display:flex}.p-fluid .p-dropdown .p-dropdown-label{width:1%}}ui-input-dropdown .p-fluid .p-dropdown{width:100%;min-width:100%}ui-input-dropdown{--borderLeftRadius:var(--inputBorderRadius);--borderRightRadius:var(--inputBorderRadius)}ui-input-dropdown.display-inline{display:inline-block}ui-input-dropdown:not(.display-inline){display:block}ui-input-dropdown .loading{margin:7px 2px 2px 7px}ui-input-dropdown .p-dropdown{background:var(--inputBgColor);border:1px solid #a6a6a6;border-color:var(--inputBorderColor);min-width:120px;max-width:100%;flex:1;display:flex;align-items:center;position:relative;overflow:hidden;border-radius:var(--borderLeftRadius);border-top-right-radius:var(--borderRightRadius);border-bottom-right-radius:var(--borderRightRadius);height:var(--inputHeight)}body.a11y-highlight-interactible ui-input-dropdown .p-dropdown{outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.p-width-100>ui-input-dropdown .p-dropdown,.p-width-stretch>ui-input-dropdown .p-dropdown{width:100%}ui-input-dropdown .p-dropdown{transition:border-color .3s,background-color .3s}ui-input-dropdown .p-dropdown[readonly],ui-input-dropdown .p-dropdown[disabled]{border-color:var(--inputDisabledBorderColor);background-color:var(--inputDisabledBgColor);color:var(--inputDisabledTextColor);cursor:default!important;pointer-events:none}ui-input-dropdown .p-dropdown::ng-deep:not(.p-disabled,[readonly]):hover{border-color:var(--inputHoverBorderColor);background-color:var(--inputHoverBgColor)}ui-input-dropdown .p-dropdown::ng-deep:not(.p-disabled,[readonly]):focus{border-color:var(--focusColor);outline:0 none;box-shadow:none}body.a11y-emphasize-focus ui-input-dropdown .p-dropdown::ng-deep:not(.p-disabled,[readonly]):focus{border-width:3px!important}ui-input-dropdown .p-dropdown .p-dropdown-label{padding:var(--inputPadding);height:auto!important;border:0}ui-input-dropdown .p-dropdown .p-dropdown-clear-icon{position:absolute;right:35px;top:55%}ui-input-dropdown .p-dropdown .p-dropdown-trigger{background-color:var(--inputBgColor);height:100%;display:flex;justify-content:flex-start;width:1.5em;text-align:left;padding:0;color:var(--inputDropdownIconColor)}ui-input-dropdown .p-dropdown::ng-deep:not(.p-disabled,[readonly]) .p-state-focus{border-color:var(--focusColor);outline:0 none;box-shadow:none}body.a11y-emphasize-focus ui-input-dropdown .p-dropdown::ng-deep:not(.p-disabled,[readonly]) .p-state-focus{border-width:3px!important}ui-input-dropdown.p-inputwrapper-focus .p-dropdown,ui-input-dropdown .p-dropdown:focus{border-color:var(--focusColor);outline:0 none;box-shadow:none}body.a11y-emphasize-focus ui-input-dropdown.p-inputwrapper-focus .p-dropdown,body.a11y-emphasize-focus ui-input-dropdown .p-dropdown:focus{border-width:3px!important}.p-dropdown.small .p-dropdown-label{padding:0 2em 0 .5em}.p-dropdown-panel{padding:0;border:1px solid #c8c8c8;border-color:var(--inputOverlayBorderColor);background-color:var(--inputListBgColor);box-shadow:var(--inputOverlayShadow);max-width:90vw}.p-dropdown-panel .p-dropdown-filter-container{padding:6px 15px;border-bottom:1px solid #eaeaea;border-bottom-color:var(--inputListHeaderBorderColor);color:var(--inputListHeaderTextColor);background-color:var(--inputListHeaderBgColor);margin:0}.p-dropdown-panel .p-dropdown-filter-container .p-dropdown-filter{width:100%;padding-right:2em}.p-dropdown-panel .p-dropdown-filter-container .p-dropdown-filter-icon{top:50%;margin-top:-6px;right:21px;color:var(--inputListHeaderSearchIconColor)}.p-dropdown-panel .p-dropdown-items{padding:0}.p-dropdown-panel .p-dropdown-empty-message{padding:6px 15px}.p-dropdown-panel .p-dropdown-item-group{padding:6px 15px;font-weight:700;background:var(--inputListGroupLabelBgColor);color:var(--inputListGroupLabelTextColor)}.p-dropdown-item{list-style-type:none;margin:0;padding:6px 15px;border:0 none;border-color:var(--inputListItemBorderColor);color:var(--inputListItemTextColor);background-color:var(--inputListItemBgColor);border-radius:0}body.a11y-highlight-interactible .p-dropdown-item{outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.p-dropdown-item:focus,.p-dropdown-item.p-focus{background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}.p-dropdown-item.p-highlight{color:var(--inputListItemHighlightTextColor);background-color:var(--inputListItemHighlightBgColor)}.p-dropdown-item:not(.p-highlight):not(.p-disabled):hover{color:var(--inputListItemHoverTextColor);background-color:var(--inputListItemHoverBgColor)}\n";
export const DROPDOWN_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputDropdownComponent),
  multi: true
};
export let DropdownItem = /*#__PURE__*/(() => {
  class DropdownItem extends DropdownBaseItem {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵDropdownItem_BaseFactory;
        return function DropdownItem_Factory(__ngFactoryType__) {
          return (ɵDropdownItem_BaseFactory || (ɵDropdownItem_BaseFactory = i0.ɵɵgetInheritedFactory(DropdownItem)))(__ngFactoryType__ || DropdownItem);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: DropdownItem,
        selectors: [["p-dropdownItem"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 21,
        consts: [["role", "option", "e2e-drop-down-item", "", "pRipple", "", 3, "click", "mouseenter", "id", "ngStyle", "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]],
        template: function DropdownItem_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "li", 0);
            i0.ɵɵlistener("click", function DropdownItem_Template_li_click_0_listener($event) {
              return ctx.onOptionClick($event);
            })("mouseenter", function DropdownItem_Template_li_mouseenter_0_listener($event) {
              return ctx.onOptionMouseEnter($event);
            });
            i0.ɵɵconditionalCreate(1, DropdownItem_Conditional_1_Template, 2, 1, "span");
            i0.ɵɵtemplate(2, DropdownItem_ng_container_2_Template, 1, 0, "ng-container", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.id)("ngStyle", i0.ɵɵpureFunction1(13, _c0, ctx.itemSize + "px"))("ngClass", i0.ɵɵpureFunction3(15, _c1, ctx.selected, ctx.disabled, ctx.focused));
            i0.ɵɵattribute("aria-label", ctx.label)("aria-setsize", ctx.ariaSetSize)("aria-posinset", ctx.ariaPosInset)("aria-selected", ctx.selected)("data-p-focused", ctx.focused)("data-p-highlight", ctx.selected)("data-p-disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.template ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(19, _c2, ctx.option));
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, ScrollingModule, AutoFocusModule, OverlayModule, ScrollerModule],
        styles: [_c8],
        encapsulation: 2
      });
    }
  }
  return DropdownItem;
})();
const DROPDOWN_DEFAULT_PLACEHOLDER = 'Bitte wählen...';
const DROPDOWN_DEFAULT_PLACEHOLDER_OPTION = '[nichts auswählen]';
export let UiInputDropdownComponent = /*#__PURE__*/(() => {
  class UiInputDropdownComponent extends DropdownBase {
    constructor() {
      super(...arguments);
      this.dataKey = null; // data key is used to work with objects as values
      // lock to false as this behavior is undesired: It would show a value but for validation there's no value.
      // you'd first have to select another value to make the Dropdown emit a value change.
      this.autoDisplayFirst = false;
      this.loading = false;
      this.inline = false;
      this.showClear = false;
      this.appendTo = 'body';
      this.emptyFilterMessage = 'Keine Ergebnisse gefunden.';
      // overwrite default placeholder value
      this._placeholder = signal(DROPDOWN_DEFAULT_PLACEHOLDER, ...(ngDevMode ? [{
        debugName: "_placeholder"
      }] : /* istanbul ignore next */[]));
      this.placeholderOptionLabel = computed(() => {
        const p = this._placeholder();
        if (p === DROPDOWN_DEFAULT_PLACEHOLDER) return DROPDOWN_DEFAULT_PLACEHOLDER_OPTION;else return p;
      }, ...(ngDevMode ? [{
        debugName: "placeholderOptionLabel"
      }] : /* istanbul ignore next */[]));
      this.fieldWrapperState = signal(null, ...(ngDevMode ? [{
        debugName: "fieldWrapperState"
      }] : /* istanbul ignore next */[]));
      this.displayResetOption = true; // when true, a "deselect" item will be added to options list
      this.enablePlaceholder = true;
      this.showPlaceholder = computed(() => {
        if (!this.enablePlaceholder) return false;
        if (this.fieldWrapperState()?.hasPlaceholder) return false;
        const modelValue = this.modelValue();
        // if no option is selected, label will return placeholder value
        const hasNoValue = modelValue === undefined || modelValue === null;
        return hasNoValue; //&& (labelEqPlaceholder || (label && !placeholder))
      }, ...(ngDevMode ? [{
        debugName: "showPlaceholder"
      }] : /* istanbul ignore next */[]));
      // label is responsible for getting the display value of inline label (so outside of the dropdown item list)
      // when null is returned, it will fall back to display placeholder/"empty" text instead.
      this.label = computed(() => {
        const selectedOptionIndex = this.findSelectedOptionIndex();
        let selectedOption = this.getSelectedOptionByIndex(selectedOptionIndex);
        if (typeof selectedOption === 'number') {
          selectedOption = selectedOption.toString();
        }
        if (!selectedOption) return null;
        // dropdown works differently in grouped and ungrouped mode.
        // ungrouped: when "nothing" is selected, selectedOption === placeholderItem.
        // grouped: when "nothing" is selected, selectedOption === null.
        // we want to return null for "nothing" selection in any case.
        if (selectedOption['isPlaceholder']) return null;
        return selectedOptionIndex !== -1 ? this.getOptionLabel(selectedOption) : this.placeholder() || 'p-emptylabel';
      }, ...(ngDevMode ? [{
        debugName: "label"
      }] : /* istanbul ignore next */[]));
    }
    // fix classes for correct display of placeholder (p-dropdown-label-empty was ignoring existence of placeholder)
    get inputClass() {
      const label = this.label();
      return {
        'p-dropdown-label p-inputtext p-input-text': true,
        'p-placeholder': this.placeholder() && label === this.placeholder(),
        'p-dropdown-label-empty': !this.editable && !this.selectedItemTemplate && !this.placeholder() && (label === undefined || label === null || label === 'p-emptylabel' || label.length === 0)
      };
    }
    // as of v17.6, set options is the only way primeNG writes to _options.
    // overriding it in order to have addResetOption process incoming options list before updating UI.
    get options() {
      const options = this._options();
      return options;
    }
    set options(val) {
      if (!ObjectUtils.deepEquals(val, this._options())) {
        this._options.set(this.addResetOption(val));
      }
    }
    markForCheck() {
      this.cd.markForCheck();
    }
    onUpdateFieldWrapperState(state) {
      this.fieldWrapperState.set(state);
    }
    onContainerClick(event) {
      if (this.disabled || this.readonly) {
        console.log('listbox - ignore click as its disabled/readonly');
        return;
      }
      this.focusInputViewChild?.nativeElement.focus({
        preventScroll: true
      });
      if (event.target.tagName === 'INPUT' || event.target.getAttribute('data-pc-section') === 'clearicon' || event.target.closest('[data-pc-section="clearicon"]')) {
        console.log('listbox - ignore click as it has invalid target');
        return;
      } else if (!this.overlayViewChild || !this.overlayViewChild.el.nativeElement.contains(event.target)) {
        console.log('listbox - toggle overlay to ' + !this.overlayVisible);
        this.overlayVisible ? this.hide(true) : this.show(true);
      }
      this.onClick.emit(event);
      this.clicked.set(true);
      this.cd.detectChanges();
    }
    /** adds a custom placeholder-like "reset" entry to the options to display in dropdown list.
     */
    addResetOption(options) {
      if (!options) return options;
      if (!this.displayResetOption || !this._placeholder()) return options;
      const placeholderItem = createPlaceholderEntryItem(this.placeholderOptionLabel(), this.optionLabel, this.optionValue);
      const hasPlaceholderItem = options[0] && this.isPlaceholderItem(options[0]);
      if (hasPlaceholderItem) {
        options[0] = placeholderItem;
      } else {
        options.unshift(placeholderItem);
      }
      return options;
    }
    isPlaceholderItem(option) {
      return option.isPlaceholder || option.group && option.optionGroup.isPlaceholder;
    }
    /**
     * isValidOption is unmodified but left here for clarity.
     * isValidOption is checked for selectable as well as selected options.
     * due to this, disabled options cannot be selected.
     * When passing in options, ensure that the active option is not disabled!
     */
    isValidOption(option) {
      const valid = option !== undefined && option !== null && !this.isOptionDisabled(option) && !this.isOptionGroup(option);
      return valid;
    }
    // custom implementation to better understand whats going on.
    // added custom check for placeholderItem, as canUseValue could not handle it as intended.
    getOptionValue(option) {
      const hasOptionValue = this.optionValue && this.optionValue !== null;
      if (hasOptionValue) return ObjectUtils.resolveFieldData(option, this.optionValue);
      if (this.isPlaceholderItem(option)) return option.value;
      const canUseValue = !this.optionLabel && option && option.value !== undefined;
      if (canUseValue) return option.value;
      return option;
    }
    // custom utility function.
    // as of 17.6, it looks like transition to signals has not yet completed.
    getSelectedOptionByIndex(index) {
      return this.visibleOptions()[index];
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiInputDropdownComponent_BaseFactory;
        return function UiInputDropdownComponent_Factory(__ngFactoryType__) {
          return (ɵUiInputDropdownComponent_BaseFactory || (ɵUiInputDropdownComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiInputDropdownComponent)))(__ngFactoryType__ || UiInputDropdownComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputDropdownComponent,
        selectors: [["ui-input-dropdown"]],
        hostAttrs: [1, "p-element", "p-inputwrapper"],
        hostVars: 6,
        hostBindings: function UiInputDropdownComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("p-inputwrapper-filled", ctx.value)("p-inputwrapper-focus", ctx.focused || ctx.overlayVisible)("display-inline", ctx.inline);
          }
        },
        inputs: {
          dataKey: "dataKey",
          inline: "inline",
          showClear: "showClear",
          appendTo: "appendTo",
          emptyFilterMessage: "emptyFilterMessage",
          options: "options",
          displayResetOption: "displayResetOption",
          enablePlaceholder: "enablePlaceholder"
        },
        features: [i0.ɵɵProvidersFeature([DROPDOWN_VALUE_ACCESSOR, {
          provide: INPUT_OPTIONS_DYNAMIC_HOST,
          useExisting: forwardRef(() => UiInputDropdownComponent)
        }, {
          provide: OPTIONS_GROUPED_BY_HOST,
          useExisting: forwardRef(() => UiInputDropdownComponent)
        }, {
          provide: FIELD_WRAPPER_LISTENER,
          useExisting: forwardRef(() => UiInputDropdownComponent)
        }]), i0.ɵɵHostDirectivesFeature([i2.InputRefDirective, {
          directive: i3.FormControlNameStandalone,
          inputs: ["formControlName", "formControlNameStandalone"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 25,
        vars: 41,
        consts: [["container", ""], ["overlay", ""], ["firstHiddenFocusableEl", ""], ["buildInItems", ""], ["lastHiddenFocusableEl", ""], ["focusInput", ""], ["editableInput", ""], ["filter", ""], ["scroller", ""], ["items", ""], ["e2e-dropdown", "", 3, "click", "ngClass", "ngStyle"], ["e2e-dropdown-label", "", "role", "combobox", "pAutoFocus", "", 3, "ngClass", "autofocus"], ["e2e-dropdown-label", "", 3, "ngClass"], ["e2e-dropdown-label", "", "type", "text", "aria-haspopup", "listbox", 3, "ngClass", "disabled"], ["role", "button", "aria-label", "dropdown trigger", "aria-haspopup", "listbox", 1, "p-dropdown-trigger"], [1, "p-dropdown-trigger-icon"], [3, "visibleChange", "onAnimationStart", "onHide", "visible", "options", "target", "appendTo", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions"], [3, "ngClass", "ngStyle"], ["role", "presentation", 1, "p-hidden-accessible", "p-hidden-focusable", 3, "focus"], [1, "loading"], [4, "ngTemplateOutlet"], [1, "p-dropdown-header"], [1, "p-dropdown-items-wrapper"], [3, "items", "style", "itemSize", "autoSize", "lazy", "options"], ["e2e-dropdown-label", "", "role", "combobox", "pAutoFocus", "", 3, "focus", "blur", "keydown", "ngClass", "autofocus"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["e2e-dropdown-label", "", "type", "text", "aria-haspopup", "listbox", 3, "input", "keydown", "focus", "blur", "ngClass", "disabled"], [3, "styleClass"], [1, "p-dropdown-clear-icon"], [3, "click", "styleClass"], [1, "p-dropdown-clear-icon", 3, "click"], [1, "p-dropdown-trigger-icon", 3, "ngClass"], [3, "size", "margin", "inline"], [1, "p-dropdown-header", 3, "click"], [1, "p-dropdown-filter-container"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["e2e-dropdown-filter", "", "type", "text", "autocomplete", "off", 1, "p-dropdown-filter", "p-inputtext", "p-input-text", "p-component", 3, "input", "keydown", "blur", "value"], [1, "p-dropdown-filter-icon"], [3, "onLazyLoad", "items", "itemSize", "autoSize", "lazy", "options"], ["pTemplate", "content"], ["pTemplate", "loader"], ["role", "listbox", 1, "p-dropdown-items", 3, "ngClass"], [1, "p-dropdown-empty-message", 3, "ngStyle"], [3, "ngClass", "id", "option", "selected", "label", "disabled", "template", "focused", "ariaPosInset", "ariaSetSize"], [1, "p-dropdown-placeholder-item", 3, "option", "selected", "label", "disabled"], ["role", "option", 1, "p-dropdown-item-group", 3, "ngStyle"], [1, "p-dropdown-placeholder-item", 3, "onClick", "option", "selected", "label", "disabled"], [3, "onClick", "onMouseEnter", "ngClass", "id", "option", "selected", "label", "disabled", "template", "focused", "ariaPosInset", "ariaSetSize"]],
        template: function UiInputDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 10, 0);
            i0.ɵɵlistener("click", function UiInputDropdownComponent_Template_div_click_0_listener($event) {
              return ctx.onContainerClick($event);
            });
            i0.ɵɵconditionalCreate(2, UiInputDropdownComponent_Conditional_2_Template, 5, 16, "span", 11);
            i0.ɵɵconditionalCreate(3, UiInputDropdownComponent_Conditional_3_Template, 2, 4, "span", 12);
            i0.ɵɵconditionalCreate(4, UiInputDropdownComponent_Conditional_4_Template, 2, 5, "input", 13);
            i0.ɵɵconditionalCreate(5, UiInputDropdownComponent_Conditional_5_Template, 2, 2);
            i0.ɵɵelementStart(6, "div", 14);
            i0.ɵɵconditionalCreate(7, UiInputDropdownComponent_Conditional_7_Template, 2, 2);
            i0.ɵɵconditionalCreate(8, UiInputDropdownComponent_Conditional_8_Template, 2, 1, "span", 15);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "p-overlay", 16, 1);
            i0.ɵɵtwoWayListener("visibleChange", function UiInputDropdownComponent_Template_p_overlay_visibleChange_9_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.overlayVisible, $event) || (ctx.overlayVisible = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onAnimationStart", function UiInputDropdownComponent_Template_p_overlay_onAnimationStart_9_listener($event) {
              return ctx.onOverlayAnimationStart($event);
            })("onHide", function UiInputDropdownComponent_Template_p_overlay_onHide_9_listener() {
              return ctx.hide();
            });
            i0.ɵɵelementStart(11, "div", 17)(12, "span", 18, 2);
            i0.ɵɵlistener("focus", function UiInputDropdownComponent_Template_span_focus_12_listener($event) {
              return ctx.onFirstHiddenFocus($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(14, UiInputDropdownComponent_Conditional_14_Template, 2, 3, "span", 19);
            i0.ɵɵtemplate(15, UiInputDropdownComponent_ng_container_15_Template, 1, 0, "ng-container", 20);
            i0.ɵɵconditionalCreate(16, UiInputDropdownComponent_Conditional_16_Template, 3, 1, "div", 21);
            i0.ɵɵelementStart(17, "div", 22);
            i0.ɵɵconditionalCreate(18, UiInputDropdownComponent_Conditional_18_Template, 4, 10, "p-scroller", 23);
            i0.ɵɵconditionalCreate(19, UiInputDropdownComponent_Conditional_19_Template, 1, 6, "ng-container");
            i0.ɵɵtemplate(20, UiInputDropdownComponent_ng_template_20_Template, 6, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(22, UiInputDropdownComponent_ng_container_22_Template, 1, 0, "ng-container", 20);
            i0.ɵɵelementStart(23, "span", 18, 4);
            i0.ɵɵlistener("focus", function UiInputDropdownComponent_Template_span_focus_23_listener($event) {
              return ctx.onLastHiddenFocus($event);
            });
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", ctx.containerClass)("ngStyle", ctx.style);
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.editable ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.editable && ctx.label == null ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.editable ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isVisibleClearIcon ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-expanded", ctx.overlayVisible)("data-pc-section", "trigger");
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.dropdownIconTemplate ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.dropdownIconTemplate ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("visible", ctx.overlayVisible);
            i0.ɵɵproperty("options", ctx.overlayOptions)("target", "@parent")("appendTo", ctx.appendTo)("autoZIndex", ctx.autoZIndex)("baseZIndex", ctx.baseZIndex)("showTransitionOptions", ctx.showTransitionOptions)("hideTransitionOptions", ctx.hideTransitionOptions);
            i0.ɵɵadvance(2);
            i0.ɵɵclassMap(ctx.panelStyleClass);
            i0.ɵɵproperty("ngClass", "p-dropdown-panel p-component")("ngStyle", ctx.panelStyle);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-hidden", true)("tabindex", 0)("data-p-hidden-accessible", true)("data-p-hidden-focusable", true);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.loading ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.filter ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("max-height", ctx.virtualScroll ? "auto" : ctx.scrollHeight || "auto");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.virtualScroll ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.virtualScroll ? 19 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.footerTemplate);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-hidden", true)("tabindex", 0)("data-p-hidden-accessible", true)("data-p-hidden-focusable", true);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, ScrollingModule, UiSpinnerComponent, AutoFocusModule, i4.AutoFocus, OverlayModule, i5.Overlay, i6.PrimeTemplate, ScrollerModule, i7.Scroller, TimesIcon, ChevronDownIcon, SearchIcon, DropdownItem, SharedModule],
        styles: [_c8],
        encapsulation: 2,
        data: {
          animation: []
        },
        changeDetection: 0
      });
    }
  }
  return UiInputDropdownComponent;
})();
export const UiInputDropdownBundle = [UiInputDropdownComponent, ...UiHeaderFooterBundle];